import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "../css/privacy.scss";

function FAQs() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="main-content">
      <div className="shopify-policy__container">
        <div className="shopify-policy__title">
          <h1>Frequently Asked Questions</h1>
        </div>
        <div className="shopify-policy__body">
          <div className="rte">
            <h2>What is included with my hardware?</h2>
            <p>
              The included components are listed on each product page. Please
              check the product information before installation, as wall type
              and cabinetry construction may require different fixings.
            </p>

            <h2>How do I choose the right size?</h2>
            <p>
              Compare the dimensions and centre-to-centre measurement shown on
              the product page with your existing holes or planned placement.
              If you are unsure, contact us before drilling.
            </p>

            <h2>Will finishes change over time?</h2>
            <p>
              Natural and unlacquered metals can develop a patina. Finish and
              care information is provided on each product page. Clean hardware
              with warm water and mild soap, and avoid abrasive cleaners.
            </p>

            <h2>When will my order be dispatched?</h2>
            <p>
              Orders are normally processed within 1–2 business days. Available
              services and estimated transit times are listed in our {" "}
              <Link to="/shipping">Shipping Policy</Link>.
            </p>

            <h2>Can I return an item?</h2>
            <p>
              Eligible unused items may be returned in their original condition
              and packaging. Please read our <Link to="/returns">Refund Policy</Link>{" "}
              for time limits, exclusions and refund details.
            </p>

            <h2>How can I contact Pedarcircle?</h2>
            <p>
              Email us at {" "}
              <a href="mailto:draft@pedarcircle.club">
                draft@pedarcircle.club
              </a>
              . Please include your order number when asking about an order.
            </p>
          </div>
        </div>
      </div>
    </main>
  );
}

export default FAQs;
